import changeSelectedFilePickerViewBasedOnUserPreferredView from './changeSelectedFilePickerViewBasedOnUserPreferredView';
import changeSelectedFileProviderToDefault from './changeSelectedFileProviderToDefault';
import changeUserPreferredViewType from './changeUserPreferredViewType';
import refreshFileProviderItems from './refreshFileProviderItems';
import setCustomUploadConfiguration from '../actions/setCustomUploadConfiguration';
import datapoints from '../datapoints';
import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import type FilePickerUploadConfiguration from '../store/schema/FilePickerUploadConfiguration';
import type { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import type { FileSelectionFilter } from 'owa-fileprovider-store';
import { getFileProviders } from 'owa-fileprovider-store/lib/selectors/getFileProviders';
import { wrapFunctionForDatapoint } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';
import type { FileProvidersFilter } from '../store/schema/FileProvidersFilter';

export default wrapFunctionForDatapoint(
    datapoints.FPShowFilePicker,
    function showFilePicker(
        filter: FileSelectionFilter,
        fileProvidersFilter: FileProvidersFilter,
        viewType: FilePickerViewType | null,
        viewState: FilePickerPanelViewState,
        uploadConfig: FilePickerUploadConfiguration | null
    ) {
        const previousFileSelectionFilter = viewState.fileSelectionFilter;
        const previousFileProvidersFilter = viewState.fileProvidersFilter;

        if (getFileProviders().length === 0) {
            // If there are no file providers in the viewState then
            // call the action to get all the file providers that user has
            // TODO: See what needs to be done if the user has no file provider. Here we will always make a service call in that case
            if (!viewState.selectedFileProvider && getFileProviders().length !== 0) {
                changeSelectedFileProviderToDefault(
                    filter,
                    fileProvidersFilter,
                    previousFileSelectionFilter,
                    previousFileProvidersFilter,
                    viewState
                );

                if (viewType !== null) {
                    changeSelectedFilePickerViewBasedOnUserPreferredView(
                        viewState.selectedFileProvider,
                        viewState.filePickerViewState
                    );
                }
            }
        } else {
            // We need to update the file provider to show based on the
            // selection filter and select the default provider
            changeSelectedFileProviderToDefault(
                filter,
                fileProvidersFilter,
                previousFileSelectionFilter,
                previousFileProvidersFilter,
                viewState
            );
        }

        setFilePickerPanelFilter(viewState, filter, fileProvidersFilter);
        if (viewType !== null) {
            // If a view type was provided then set is as the user preferred view
            changeUserPreferredViewType(viewType, viewState.filePickerViewState);

            if (viewState.selectedFileProvider) {
                changeSelectedFilePickerViewBasedOnUserPreferredView(
                    viewState.selectedFileProvider,
                    viewState.filePickerViewState
                );
            }
        }
        if (uploadConfig) {
            setCustomUploadConfiguration(uploadConfig);
        }

        setFilePickerIsOpen(viewState);

        refreshFileProviderItems();
    }
);

const setFilePickerPanelFilter = mutatorAction(
    'setFilePickerPanelFilter',
    (
        viewState: FilePickerPanelViewState,
        filter: FileSelectionFilter,
        fileProvidersFilter: FileProvidersFilter
    ) => {
        viewState.fileSelectionFilter = filter;
        viewState.fileProvidersFilter = fileProvidersFilter;
    }
);

const setFilePickerIsOpen = mutatorAction(
    'setFilePickerIsOpen',
    (viewState: FilePickerPanelViewState) => {
        viewState.isOpen = true;
    }
);
